<template>
  <LazyHomeCommonLayout :is-blog-banner="true">
    <template #content>
      <LazyHomeSubPagesSolutionHiringContent />
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {LazyHomeSubPagesSolutionHiringContent} from "#components";
import {useSiteNavigationLd} from "~/composables/useSiteNavigationLd";
import {useSeoMeta} from "~/composables/useSeoMeta";

const { t } = useI18n();
const siteLinkScript = useSiteNavigationLd();
const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: t("seo.home.hiring.title"),
  meta: [
    {
      name: 'description',
      content: t("seo.home.hiring.meta.description")
    },
    {
      name: 'title',
      content: t("seo.home.hiring.meta.title")
    },
    {
      name: 'robots',
      content: 'index,follow'
    }
  ],
  script: [siteLinkScript],
  link: [
    ...getHreflangLinks.value,
    { rel: 'canonical', href: getCanonical.value }
  ]
})

definePageMeta({
  // 언어별 경로를 alias로 추가
  alias: [
    '/en/home/hiring',
    '/ja/home/hiring',
    '/ko/home/hiring',
    '/vi/home/hiring',
  ]
})
</script>